import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DecimalFormatterDirective } from './decimal-formatter.directive';
import { MoneyFormatterDirective } from './money-formatter.directive';
import { NoScrollDirective } from './no-number-scroll.directive';


@NgModule({
  declarations: [DecimalFormatterDirective, MoneyFormatterDirective],
  exports: [DecimalFormatterDirective, MoneyFormatterDirective, NoScrollDirective],
  imports: [CommonModule, NoScrollDirective]
})
export class DirectivesModule {}
